import styled from 'styled-components';
import Grid from '@klv/utils/grid';
import Typography from '@klv/atoms/typography';
import { GradientText } from '../../../atoms/gradient-text';

export const Wrapper = styled(Grid)`
  display: block;
`;

export  const StyledProducts = styled.div`
  padding: 6.4rem 0;

  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      padding: 10.8rem 0;
    }
  `}
`;

export const ArrowsSvg = styled.svg`
  display: none;
  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      display: block;
      width: 77%;
      margin: auto;
    }
  `}
`;

export const HeadlineGrid = styled(Grid)`
  padding: 0;
  margin: 0;
`;

export const StyledHeadline = styled(Typography)`
  ${({ theme }) => `
    ${theme.fonts.sohne.light}
    grid-column: 1/-1;
    text-align: center;
    font-size: 2.4rem;
    line-height: 1.15;
    margin-bottom: 3.6rem;
    color: ${theme.colors.charcoal};
    ${theme.screenSize.s576.mediaQuery} {
      font-size: 2.8rem;
    }
    ${theme.screenSize.s768.mediaQuery} {
      font-size: 3.2rem;
      line-height: 1.4;
      grid-column: 2 / 12;
    }
    ${theme.screenSize.s1024.mediaQuery} {
      font-size: 3.6rem;
      line-height: 1.15;
      margin-bottom: 6.4rem;
    }
    ${theme.screenSize.s1200.mediaQuery} {
      font-size: 4.8rem;
      line-height: 1.3;
    }
  `}
  
  strong {
    ${GradientText}
    font-weight: 300;
  }
`;

export const ProductContainer = styled(Grid)`
  width: 100%;
  border-radius: 1.5rem;
  padding-left: 0;
  padding-right: 0;
  gap: 2.4rem;
  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      column-gap: 2.6rem;
    }
  `}
`;
